import React, { useRef, useState } from 'react';
import { Animated, Easing, StyleSheet, Text, TouchableWithoutFeedback, View, } from 'react-native';
import { Icon } from "../../icon/Icon";
import { ColorTokens, IconSizeTokens, IconTokens } from "@voltmoney/schema";
const AccordionListItem = ({ id, title, children, subTitle, paddingVertical = 18, paddingHorizontal = 18, childBodyStyle = {
    padding: 16,
    paddingLeft: 24,
    paddingRight: 0
} }) => {
    const [open, setOpen] = useState(false);
    const animatedController = useRef(new Animated.Value(0)).current;
    const [bodySectionHeight, setBodySectionHeight] = useState(0);
    const bodyHeight = animatedController.interpolate({
        inputRange: [0, 1],
        outputRange: [0, bodySectionHeight],
    });
    const arrowAngle = animatedController.interpolate({
        inputRange: [0, 1],
        outputRange: ['0rad', `${Math.PI}rad`],
    });
    const toggleListItem = () => {
        if (open) {
            Animated.timing(animatedController, {
                useNativeDriver: false,
                duration: 300,
                toValue: 0,
                easing: Easing.bezier(0.4, 0.0, 0.2, 1)
            }).start();
        }
        else {
            Animated.timing(animatedController, {
                useNativeDriver: false,
                duration: 300,
                toValue: 1,
                easing: Easing.bezier(0.4, 0.0, 0.2, 1)
            }).start();
        }
        setOpen(!open);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TouchableWithoutFeedback, { onPress: () => toggleListItem() },
            React.createElement(View, { style: [
                    open ? styles.titleOpenContainer
                        : styles.titleContainer,
                    {
                        paddingHorizontal: paddingHorizontal,
                        paddingVertical: paddingVertical,
                    }
                ], nativeID: id },
                React.createElement(Text, { style: { color: '#1D2939' } }, title),
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(Text, { style: { fontWeight: '600' } }, subTitle),
                    React.createElement(Animated.View, { style: { transform: [{ rotateZ: arrowAngle }], marginLeft: 8, justifyContent: 'center', alignItems: 'center' } },
                        React.createElement(Icon, { name: IconTokens.DownArrow, size: IconSizeTokens.XXS, color: ColorTokens.Grey_Smoke }))))),
        React.createElement(Animated.View, { style: [styles.bodyBackground, { height: bodyHeight || 0 }] },
            React.createElement(View, { style: [
                    styles.bodyContainer,
                    childBodyStyle
                ], onLayout: event => setBodySectionHeight(event.nativeEvent.layout.height) }, children))));
};
export default AccordionListItem;
const styles = StyleSheet.create({
    bodyBackground: {
        overflow: 'hidden',
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderTopWidth: 1,
        borderColor: '#EFEFEF',
        justifyContent: 'space-between',
    },
    titleOpenContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderTopWidth: 1,
        borderColor: '#EFEFEF',
        justifyContent: 'space-between',
    },
    bodyContainer: {
        position: 'absolute',
        bottom: 0,
        width: '100%'
    },
});
